module.exports = __webpack_public_path__ + "static/img/img-about-5.9836bf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-about-5.png
// module id = BGj9
// module chunks = 0